import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import swal from "sweetalert";
import MainPagetitle from '../../layouts/MainPagetitle';
import BlogService from '../../api/services/BlogService';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
const Blog = () => {
    var imageUrl = process.env.REACT_APP_LARAVEL_BLOG_IMAGE_URL;
    const [blog, setBlog] = useState([]);
    const [Error, setError] = useState('');
    const navigate = useNavigate();
    const [isLoading, setisloading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPage = 50;
    const lastIndex = currentPage * recordsPage;
    const firstIndex = lastIndex - recordsPage;
    const records = blog.slice(firstIndex, lastIndex);
    const npage = Math.ceil(blog.length / recordsPage)
    const number = [...Array(npage + 1).keys()].slice(1)
    useEffect(() => {
        if (localStorage.getItem("admintoken")) {
            getBlog();
        }
        else {
            navigate('/')
        }
    }, []);
    function prePage() {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1)
        }
    }

    function changeCPage(id) {
        setCurrentPage(id);
    }

    function nextPage() {
        if (currentPage !== npage) {
            setCurrentPage(currentPage + 1)
        }
    }
    const getBlog = async () => {
        try {
            let blogList = await BlogService.index().json();
            setBlog(blogList.data);
            setisloading(false);
        } catch (error) {
            console.log(error);
        }
    };
    const handleDelete = async (e) => {
        try {


            let responseData = await BlogService.destroy(e).json()
            if (responseData.status === true) {
                swal("Blog Delete Succesfully").then((willDelete) => {
                    if (willDelete) {
                        getBlog();
                    }
                })

            }

        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError(errorJson.message)
            }
        }

    }
    return (
        <>
            <MainPagetitle mainTitle="Blog" pageTitle={'Blog'} parentTitle={'Home'} />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                    <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center">
                                        <h4 className="heading mb-0">Blog</h4>
                                        <div>
                                            <Link to={`/admin/add_blog/`} className="btn btn-primary btn-sm ms-1">+ Add Blog</Link> {" "}
                                        </div>
                                    </div>
                                    <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
                                        <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                            <thead>
                                                <tr>
                                                    <th>No.</th>
                                                    <th>Blog Title</th>
                                                    <th>Blog Image</th>
                                                    <th className="d-flex">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {records.map((item, index) => (
                                                    <tr key={index}>
                                                        <td><span>{index + 1}</span></td>
                                                        <td>
                                                            <div className="products">
                                                                <h6>{item.title}</h6>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <img className="img-drop-area" height={item.blog_image ? 50 : 0} width={item.blog_image ? 50 : 0} src={item.blog_image ? imageUrl + item.blog_image : "blog"} alt='blog' />
                                                        </td>
                                                        <td>
                                                            <div className="d-flex">
                                                                <Link
                                                                    to={`/admin/edit_blog/${item.id}`}
                                                                    className="btn btn-primary shadow btn-xs sharp me-1"
                                                                >
                                                                    <i className="fas fa-pencil-alt"></i>
                                                                </Link>
                                                                {/* <Button className="btn btn-danger shadow btn-xs sharp" onClick={() => {deleteBlog(item.id)}} 
                                                                >
                                                                <i className="fa fa-trash"></i>
                                                                </Button> */}
                                                                <Link
                                                                    onClick={() =>
                                                                        swal({
                                                                            title: "Are you sure?",
                                                                            text: "Once deleted, you will not be able to recover this data!",
                                                                            icon: "warning",
                                                                            buttons: true,
                                                                            dangerMode: true,
                                                                        }).then((willDelete) => {
                                                                            if (willDelete) {
                                                                                (handleDelete(item.id));
                                                                            }
                                                                        })
                                                                    }

                                                                    className="btn btn-danger shadow btn-xs sharp"
                                                                >
                                                                    <i className="fa fa-trash"></i>
                                                                </Link>
                                                            </div>
                                                        </td>

                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        <div className="d-sm-flex text-center justify-content-between align-items-center">
                                            <div className='dataTables_info'>
                                                Showing {lastIndex - recordsPage + 1} to{" "}
                                                {blog.length < lastIndex ? blog.length : lastIndex}
                                                {" "}of {blog.length} entries
                                            </div>
                                            <div
                                                className="dataTables_paginate paging_simple_numbers justify-content-center"
                                                id="example2_paginate"
                                            >
                                                <Link
                                                    className="paginate_button previous disabled"
                                                    to="#"
                                                    onClick={prePage}
                                                >
                                                    <i className="fa-solid fa-angle-left" />
                                                </Link>
                                                <span>
                                                    {number.map((n, i) => (
                                                        <Link className={`paginate_button ${currentPage === n ? 'current' : ''} `} key={i}
                                                            onClick={() => changeCPage(n)}
                                                        >
                                                            {n}

                                                        </Link>
                                                    ))}
                                                </span>
                                                <Link
                                                    className="paginate_button next"
                                                    to="#"
                                                    onClick={nextPage}
                                                >
                                                    <i className="fa-solid fa-angle-right" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isLoading && <LogoAnimationLoader />}
        </>
    );
};

export default Blog;